import { render, staticRenderFns } from "./AnnotationTypeText.vue?vue&type=template&id=9f54ae26"
import script from "./AnnotationTypeText.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports